import { toaster } from "@/utilities/toaster";
import { Guid } from "guid-typescript";
import { assign, Machine } from "xstate";
import { PAWorkFlowModule } from "@/store/modules/paWorkFlow.module";
const workFlowMachine = Machine({
    id: "workFlow",
    context: {
        mode: "",
        workFlowId: Guid.createEmpty(),
    },
    initial: "idle",
    states: {
        idle: {
            always: {
                target: "modalDormant",
            },
        },
        modalDormant: {
            on: {
                SHOW_WORKFLOW: { target: "gettingDetailsForWorkflows", actions: ["assignMode", "assignWorkFlowId"] },
            },
        },
        gettingDetailsForWorkflows: {
            invoke: {
                id: "gettingDetailsForWorkflows",
                src: (cxt, evt) => {
                    return PAWorkFlowModule.GetDetailsForWorkFlow();
                },
                onDone: { target: "checkingWorkflowMode" },
                onError: { target: "checkingWorkflowMode" },
            },
        },
        checkingWorkflowMode: {
            always: [
                {
                    target: "loadedWorkflows",
                    cond: (cxt, evt) => cxt.mode === "Add",
                },
                {
                    target: "gettingWorkflows",
                    cond: (cxt, evt) => cxt.mode === "Edit" || cxt.mode === "Clone",
                },
            ],
        },
        gettingWorkflows: {
            invoke: {
                id: "gettingWorkflows",
                src: (cxt, evt) => {
                    if (cxt.mode === "Clone") {
                        return PAWorkFlowModule.GetWorkFlowForClone(cxt.workFlowId);
                    }
                    return PAWorkFlowModule.GetWorkFlowByDetailById(cxt.workFlowId);
                },
                onDone: { target: "loadedWorkflows" },
                onError: { target: "loadedWorkflows" },
            },
        },
        loadedWorkflows: {
            on: {
                EDIT_WORKFLOW_TITLE: { target: "editWorkflowTitle" },
                SAVE_WORKFLOW: { target: "savingWorkflow" },
                EDIT_WORKFLOW: { target: "updatingWorkflow" },
                CANCEL_WORKFLOW: { target: "modalDormant" },
                MANAGE_STEP_CONFIG: { target: "manageStepConfiguration" },
            },
        },
        manageStepConfiguration: {
            on: {
                CANCEL_STEP_CONFIG: { target: "loadedWorkflows" },
                SET_STEP_CONFIG: { target: "loadedWorkflows" },
            },
        },
        editWorkflowTitle: {
            tags: "editWorkflowTitle",
            on: {
                CANCEL_WORKFLOW_TITLE: { target: "loadedWorkflows" },
                SAVE_WORKFLOW_TITLE: { target: "loadedWorkflows" },
            },
        },
        updatingWorkflow: {
            invoke: {
                id: "updatingWorkflow",
                src: (cxt, evt) => {
                    return PAWorkFlowModule.UpdateWorkFlow(evt.item);
                },
                onDone: { target: "modalDormant", actions: "showEditDone" },
                onError: { target: "loadedWorkflows" },
            },
        },
        savingWorkflow: {
            invoke: {
                id: "savingWorkflow",
                src: (cxt, evt) => {
                    return PAWorkFlowModule.SaveWorkFlow(evt.item);
                },
                onDone: { target: "modalDormant", actions: "showWorkFlowSuccess" },
                onError: { target: "loadedWorkflows" },
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        showWorkFlowSuccess: () => {
            toaster.ShowSuccess("A Workflow has been created successfully.");
        },
        showEditDone: () => {
            toaster.ShowSuccess("A Workflow has been updated successfully.");
        },
        assignMode: assign({
            mode: (context, event) => event.mode,
        }),
        assignWorkFlowId: assign({
            workFlowId: (context, event) => event.workFlowId,
        }),
    },
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 1000);
        }),
        delayedFailure: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ result: false });
            }, 2000);
        }),
    },
});
export default workFlowMachine;
